import { $ } from '@/libs/jquery/index'
import { moment } from '@/libs/moment'

$.validator.addMethod('birthday', function(value: string, element: HTMLElement): boolean {
  const isCorrect: boolean = moment(value, 'DD-MM-YYYY').isBefore(moment())

  return this.optional(element) || isCorrect
}, 'Укажите верную дату рождения')
